// extracted by mini-css-extract-plugin
export default {"header":"header--8d4da4"};